import { Box, Divider } from "@mui/material";
import Grid from "@mui/material/Grid2";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Title from "../../components/common/Title";
import { ValidationAlert } from "../../components/common/ValidationAlert";
import Layout from "../../components/layout/Layout";
import TopBarGridContainer from "../../components/layout/TopBar";
import useAlert from "../../hooks/useAlert";
import { useNatGateway } from "../../hooks/useNatGateway";
import { initGeocoderTask } from "../../services/aws/ecs";
import ActionButtons from "./components/ActionButtons";
import GeocoderForm from "./components/GeocoderForm";

function Geocoder() {
  const navigate = useNavigate();
  const { alertState, showAlert, closeAlert } = useAlert();
  const {
    isReady: natGatewayReady,
    isLoading: natGatewayLoading,
    checkStatus,
    createGateway,
  } = useNatGateway("scraper-natgw");
  const [taskSubmitting, setTaskSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    startDate: dayjs().subtract(7, "day"),
    endDate: dayjs(),
    selectedPlatforms: [],
  });

  const validateInputs = () => {
    if (formData.startDate >= formData.endDate) {
      showAlert("error", "Start Date Must Be Before End Date!");
      return false;
    }
    if (formData.selectedPlatforms.length === 0) {
      showAlert("error", "Please select at least one platform!");
      return false;
    }
    return true;
  };

  const handleSubmitTask = async () => {
    if (!validateInputs()) {
      return;
    }

    setTaskSubmitting(true);

    try {
      const res = await initGeocoderTask(formData.selectedPlatforms, formData.startDate, formData.endDate);
      showAlert("success", "Geocoder task submitted successfully!");
      setTimeout(() => {
        navigate("/tasks");
      }, 1000);
    } catch (error) {
      showAlert("error", "Failed to submit geocoder task!");
      setTaskSubmitting(false);
    }
  };

  const handleCreateNatGateway = async () => {
    showAlert("info", "Creating NAT Gateway, please wait...");
    await createGateway();
  };

  const handleFormChange = (newFormData) => {
    console.log("setting new form data", newFormData);
    setFormData(newFormData);
  };

  // Check NAT Gateway status on component mount
  useEffect(() => {
    checkStatus();
  }, []);

  return (
    <Layout>
      <ValidationAlert
        inputOpen={alertState.alertOpen}
        setInputClosed={closeAlert}
        severity={alertState.alertType}
        alertMessage={alertState.alertMsg}
      />

      {/* Top bar */}
      <TopBarGridContainer>
        <Grid>
          <Title text={"GEOCODER"} sx={{ my: 5 }} />
        </Grid>
        <Grid size="grow">
          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              mt: 5,
            }}
          >
            {/* Action Buttons */}
            <ActionButtons
              onSubmit={handleSubmitTask}
              onCreateGateway={handleCreateNatGateway}
              natGatewayReady={natGatewayReady}
              natGatewayLoading={natGatewayLoading}
              taskSubmitting={taskSubmitting}
            />
          </Box>
        </Grid>
      </TopBarGridContainer>
      <Divider variant="middle" />

      {/* Main Form */}
      <GeocoderForm formData={formData} onFormChange={handleFormChange} />
    </Layout>
  );
}

export default Geocoder;
